<template>
  <v-container fluid>
      <v-form ref="fm_credit_card">
        <v-row>
          <v-col cols="12">
            <div class='font-weight-bold'>Credit Card Payment Details</div>
            <p style="font-size:0.75em;line-height:1.25em;">Pay your monthly dues by credit card authorization (Visa/Mastercard/Discover/Amex).</p>
            <billhighway-billing-info style="font-size:0.75em;line-height:1.25em;"></billhighway-billing-info>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class='py-1'>
            <v-text-field
              ref="oma_cc_cardholder_name"
              v-model="oma_cc_cardholder_name"
              :rules="rules.oma_cc_cardholder_name"
              dense
            >
              <template #label>
                Name on the card<span class="required red--text"> *</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" class='py-1'>
            <v-text-field
              ref="oma_cc_num"
              v-model="oma_cc_num"              
              :rules="[rules__oma_cc_num]"
              v-cardformat:formatCardNumber
              validate-on-blur
            >
              <template #label>
                Card Number<span class="required red--text"> *</span>
              </template>
              <font-awesome-icon
                slot="append"
                :icon="cc_icon"
                size="lg"
              >
              </font-awesome-icon>
            </v-text-field>
          </v-col>
          <v-col cols="6" sm="3" class='py-1'>
            <v-text-field
              ref="oma_cc_expiration"
              v-model="oma_cc_expiration"              
              :rules="[rules__oma_cc_expiration]"
              hint="MM/YYYY"
              v-cardformat:formatCardExpiry
              validate-on-blur
            >
              <template #label>
                Card Expiration<span class="required red--text"> *</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="6" sm="3" class='py-1'>
            <v-text-field
              ref="oma_pmt_cc_sec_num"
              v-model="oma_pmt_cc_sec_num"
              :hint="`${oma_pmt_cc_card_type_name == 'amex'?'4':'3'} digit code on back`"
              :maxlength="oma_pmt_cc_card_type_name == 'amex'?4:3"
              :rules="[rules__oma_pmt_cc_sec_num]"
              validate-on-blur
            >
              <template #label>
                CVC Code<span class="required red--text"> *</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class='py-0'>
            <v-radio-group
              ref="oma_cc_bill_addr_alt_ind"
              v-model="oma_cc_bill_addr_alt_ind"
              :rules="rules.oma_cc_bill_addr_alt_ind"
              class="mt-0"
              row
            >
              <template #label>
                Is your billing address the same as your home address?<span class="required red--text"> *</span>
              </template>
              <v-radio
                  label="Yes"
                  value="0"
              ></v-radio>
              <v-radio
                  label="No"
                  value="1"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-container v-show="oma_cc_bill_addr_alt_ind == 1">
          <v-row>
            <v-col cols="12"  class='font-weight-bold py-0'>Billing Address</v-col>
          </v-row>
          <v-row class="justify-around">
              <v-col cols="12" class="py-0">
                  <v-text-field
                      ref="oma_cc_bill_addr_alt_street_line1"
                      v-model="oma_cc_bill_addr_alt_street_line1"
                      label="Billing Street Address Line 1"
                      required
                      :rules="[rules__oma_cc_bill_addr_alt_street_line1]"
                  >
                      <template #label>
                          Street Address Line 1<span class="required red--text"> *</span>
                      </template>
                  </v-text-field>
              </v-col>                
          </v-row>
          <v-row class="justify-around">
              <v-col cols="12" class="py-0">
                  <v-text-field
                      ref="oma_cc_bill_addr_alt_street_line2"
                      v-model="oma_cc_bill_addr_alt_street_line2"
                      label="Street Address Line 2"
                      :rules="[rules__oma_cc_bill_addr_alt_street_line2]"
                      autocomplete="dont-do-it"
                  >                        
                  </v-text-field>
              </v-col>                
          </v-row>
          <v-row class="justify-around">
              <v-col cols="12" md="5" class="py-0">
                  <v-text-field
                      ref="oma_cc_bill_addr_alt_city"
                      v-model="oma_cc_bill_addr_alt_city"
                      label="City"
                      :rules="[rules__oma_cc_bill_addr_alt_city]"
                      autocomplete="dont-do-it"
                  >
                      <template #label>
                          City<span class="required red--text"> *</span>
                      </template>
                  </v-text-field>
              </v-col>
              <v-col cols="6" md="3" class="py-0">
                  <v-autocomplete
                      ref="oma_cc_bill_addr_alt_state_code"
                      v-model="oma_cc_bill_addr_alt_state_code"
                      :rules="[rules__oma_cc_bill_addr_alt_state_code]"
                      :items="state_options"
                      item-text="val"
                      item-value="abbr"
                      label="State"
                      autocomplete="dont-do-it"
                  >
                      <template #label>
                          State<span class="required red--text"> *</span>
                      </template>
                  </v-autocomplete>
              </v-col>                
              <v-col cols="6" md="4" class="py-0">
                  <v-text-field
                      ref="oma_cc_bill_addr_alt_zip"
                      v-model="oma_cc_bill_addr_alt_zip"
                      label="Zip Code"
                      :rules="[rules__oma_cc_bill_addr_alt_zip]"
                      autocomplete="dont-do-it"
                      validate-on-blur
                  >
                      <template #label>
                          Zip Code<span class="required red--text"> *</span>
                      </template>
                  </v-text-field>
              </v-col> 
          </v-row>
        </v-container>
      </v-form>
  </v-container>
</template>

<script>
import commonMixins from '@/mixins/commonMixins';
import BillhighwayBillingInfo from './BillhighwayBillingInfo.vue'
  //import axios from 'axios'

  export default {
    name: 'IblCreditCard',
    components: {BillhighwayBillingInfo},
    mixins:[commonMixins],
    data:() => ({         
      rules: {
        oma_cc_cardholder_name: [
          v => !!v || 'Cardholder Name is required',
          v => /^[\w'\s.-]+$/.test(v) || 'Cardholder Name is invalid'
        ],
        oma_cc_bill_addr_alt_ind: [
           v => /^[01]$/.test(v) || 'Field is invalid'
        ]
      },
      cardBrand:null
    }),
    methods:{             
      rules__oma_cc_num:function(v){
        if(!this.$cardFormat.validateCardNumber(v)) return 'Invalid Card Number';
        this.oma_pmt_cc_card_type_name = this.cardBrand;
        const accepted_cc_brands = ['amex', 'discover', 'mastercard', 'visa']
        if(!accepted_cc_brands.includes(this.oma_pmt_cc_card_type_name)) return `Card brand is not accepted. Must be ${accepted_cc_brands.join(', ')}`;
        return true;
      },
      rules__oma_cc_expiration(v){
        if(!v) return 'Required';
        const regex = new RegExp(/^(\d{2})\s?\/\s?(?:20)?(\d{2})$/);
        if(regex.test(v)){
          this.oma_cc_expiration = this.$store.state.oma_cc_expiration.match(regex)[1] + " / 20" + this.$store.state.oma_cc_expiration.match(regex)[2];
          if(this.$cardFormat.validateCardExpiry(this.oma_cc_expiration)){
            this.oma_cc_exp_month = this.$store.state.oma_cc_expiration.match(regex)[1];
            this.oma_cc_exp_year = "20"+this.$store.state.oma_cc_expiration.match(regex)[2];
            return true;
          }else{
            return 'Invalid Date';
          }
        }else{
          return 'Invalid Date';
        }      
      },
      rules__oma_pmt_cc_sec_num(v){
        if(!v) return 'Required';
        return this.$cardFormat.validateCardCVC(v) || 'Invalid CVC Code';
      },
      rules__oma_cc_bill_addr_alt_street_line1:function(v){
        if(this.oma_cc_bill_addr_alt_ind != '1') return true;
        if(!v) return 'Street Address Line 1 is required';
        return /^[\w\s.,'/#:\\-]+$/.test(v) || 'Street Address is invalid'
      },
      rules__oma_cc_bill_addr_alt_street_line2:function(v){
        if(this.oma_cc_bill_addr_alt_ind != '1') return true;
        return /^[\w\s.,'/#:\\-]+$/.test(v) || 'Street Address is invalid'
      },
      rules__oma_cc_bill_addr_alt_city:function(v){
        if(this.oma_cc_bill_addr_alt_ind != '1') return true;
        if(!v) return 'City is required';
        return /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/.test(v) || 'City is invalid'
      },
      rules__oma_cc_bill_addr_alt_state_code:function(v){
        if(this.oma_cc_bill_addr_alt_ind != '1') return true;
        if(v == '') return 'State is required';
        return /^[a-zA-Z]{2}$/.test(v) || 'State is invalid'
      },
      rules__oma_cc_bill_addr_alt_zip:function(v){
        if(this.oma_cc_bill_addr_alt_ind != '1') return true;
        if(v == '') return 'Zip Code is required';
        return /^((?:[0-9]{5}(?:-[0-9]{4})?)|(?:[ABCEGHJKLMNPRSTVXY]{1}[0-9]{1}[A-Z]{1} *[0-9]{1}[A-Z]{1}[0-9]{1}))$/.test(v) || 'Zip Code is invalid'
      },      
      update_cc_num(){
          /*
          American Express: Starting with 34 or 37, length 15 digits.
          Visa: Starting with 4, length 13 or 16 digits.
          MasterCard: Starting with 51 through 55, length 16 digits.
          Discover: Starting with 6011, length 16 digits or starting with 5, length 15 digits.
          Diners Club: Starting with 300 through 305, 36, or 38, length 14 digits.
          */
          //let ccType = 'unknown';
          
          /*
          switch (this.oma_cc_num.substr(0,1)) {
            case "4":
              ccType = "visa";
              break;
            default:
              switch (this.oma_cc_num.substr(0,2)) {
                  case "30":
                      ccType = "diners";
                      break;
                  case "34":
                      ccType = "amex";
                      break;
                  case "36":
                      ccType = "diners";
                      break;
                  case "38":
                      ccType = "diners";
                      break;
                  case "37":
                      ccType = "amex";
                      break;
                  case "51":
                      ccType = "mastercard";
                      break;
                  case "55":
                      ccType = "mastercard";
                      break;
                  case "60":
                      ccType = "discover";
                      break;
                  case "62":
                      ccType = "discover";
                      break;
                  case "64":
                      ccType = "discover";
                      break;
                  case "65":
                      ccType = "discover";
                      break;
                  }
              }
          */
      }
    },
    computed:{
      cc_icon: function(){
        const brand = this.oma_pmt_cc_card_type_name || 'unknown';
        let cardBrandToClass = {
            'visa': 'fab fa-cc-visa',
            'mastercard': 'fab fa-cc-mastercard',
            'amex': 'fab fa-cc-amex',
            'discover': 'fab fa-cc-discover',
            'diners': 'fab fa-cc-diners-club',
            'jcb': 'fab fa-cc-jcb',
            'unknown': 'fa fa-credit-card',
        };
        return cardBrandToClass[brand];        
      },
      state_options(){
        return this.$store.state.stateOptions;
      },
      oma_cc_bill_addr_alt_ind:{
        get(){
            return this.$store.state.oma_cc_bill_addr_alt_ind;
        },
        set(value){
            this.$store.state.oma_cc_bill_addr_alt_ind = value;
        }
      },
      oma_cc_cardholder_name:{
        get(){
            return this.$store.state.oma_cc_cardholder_name;
        },
        set(value){
            this.$store.state.oma_cc_cardholder_name = value;
        }
      },
      oma_cc_num: {
        get(){
            return this.$store.state.oma_cc_num;
        },
        set(value){
            this.$store.state.oma_cc_num = value;
        }
      },
      oma_pmt_cc_num_last4: {
        get(){
          return this.$store.getters.getCCLast4;
        }
      },
      oma_cc_expiration:{
        get(){
            return this.$store.state.oma_cc_expiration;
        },
        set(value){
            this.$store.state.oma_cc_expiration = value;
        }
      },
      oma_cc_exp_month:{
        get(){
            return this.$store.state.oma_cc_exp_month;
        },
        set(value){
          this.$store.state.oma_cc_exp_month = value;
        }
      },
      oma_cc_exp_year:{
        get(){
            return this.$store.state.oma_cc_exp_year;
        },
        set(value){
          this.$store.state.oma_cc_exp_year = value;
        }
      },
      oma_pmt_cc_sec_num: {
        get(){
            return this.$store.state.oma_pmt_cc_sec_num;
        },
        set(value){
            this.$store.state.oma_pmt_cc_sec_num = value;
        }
      },
      oma_cc_bill_addr_alt_zip:{
        get(){
            return this.$store.state.oma_cc_bill_addr_alt_zip;
        },
        set(value){
            this.$store.state.oma_cc_bill_addr_alt_zip = value;
        }
      },
      oma_cc_bill_addr_alt_street_line2:{
        get(){
            return this.$store.state.oma_cc_bill_addr_alt_street_line2;
        },
        set(value){
            this.$store.state.oma_cc_bill_addr_alt_street_line2 = value;
        }
      },
      oma_cc_bill_addr_alt_street_line1:{
        get(){
            return this.$store.state.oma_cc_bill_addr_alt_street_line1;
        },
        set(value){
            this.$store.state.oma_cc_bill_addr_alt_street_line1 = value;
        }
      },
      oma_cc_bill_addr_alt_state_code:{
        get(){
            return this.$store.state.oma_cc_bill_addr_alt_state_code;
        },
        set(value){
            this.$store.state.oma_cc_bill_addr_alt_state_code = value;
        }
      },
      oma_cc_bill_addr_alt_city:{
        get(){
            return this.$store.state.oma_cc_bill_addr_alt_city;
        },
        set(value){
            this.$store.state.oma_cc_bill_addr_alt_city = value;
        }
      },
      oma_pmt_cc_card_type_name:{
        get(){
            return this.$store.state.oma_pmt_cc_card_type_name;
        },
        set(value){
            this.$store.state.oma_pmt_cc_card_type_name = value;
        }
      }
    }
  }
</script>

<style scoped>
</style>